<div class="filter-container">
  <div *ngIf="isSingleChoiceFilter()" class="single-choice-filter">
    <woo-dropdown
      [labelText]="translate(filterOption.filter_key)"
      [labelColor]="'#4c4644'"
      [items] = "filterOption.values"
      [(ngModel)]="selected.singleChoiceValue"
      (ngModelChange)="notify()"
      placeholder="Filtrera..."
    ></woo-dropdown>
  </div>
  <div class="multiple-choice-filter" *ngIf="isMultiChoiceFilter()">
    <woo-dropdown
      [labelText]="translate(filterOption.filter_key)"
      [labelColor]="'#4c4644'"
      [items] = "filterOption.values"
      [(ngModel)]="selected.multiChoiceValue"
      (ngModelChange)="notify()"
      [multiple]="true"
      placeholder="Filtrera..."
    ></woo-dropdown>
  </div>
  <div class="form-group" *ngIf="isSingleChoiceFilterAndRequired()">
    <div class="filter-option-label">{{translate(filterOption.filter_key)}}</div>
    <div class="filter-radio">
      <input id="inventory-filter-radio-{{filterOption.filter_key}}-1" name="group-{{filterOption.filter_key}}" type="radio"
      [(ngModel)]="selected.singleChoiceRequiredValue" [value]="filterOption.values[0]" (change)="notify()" class="radio">
      <label for="inventory-filter-radio-{{filterOption.filter_key}}-1" class="radio">
        {{translate(filterOption.values[0].name)}}
      </label>
    </div>
    <div class="filter-radio">
      <input id="inventory-filter-radio-{{filterOption.filter_key}}-2" name="group-{{filterOption.filter_key}}" type="radio"
      [(ngModel)]="selected.singleChoiceRequiredValue" [value]="filterOption.values[1]" (change)="notify()" class="radio">
      <label for="inventory-filter-radio-{{filterOption.filter_key}}-2" class="radio">
        {{translate(filterOption.values[1].name)}}
      </label>
    </div>
  </div>
</div>
